import _ from 'lodash';
// import classNames from 'classnames';
import update from 'immutability-helper';
import React, {PropTypes} from 'react';
import withScrolling from 'react-dnd-scrollzone';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { withRouter } from 'react-router';
import FontAwesome from 'react-fontawesome';
import * as actions from '../../../actions/regActions';
import RichDescription from '../../../components/common/RichDescription';
import RegMemberList from './RegMemberList';
import TeamForm from './TeamForm';

const ScrollZone = withScrolling('div');

class TeamInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.updateTeam = this.updateTeam.bind(this);
    this.checkStaticTeam = this.checkStaticTeam.bind(this);
    this.newID = this.newID.bind(this);
    this.getTeamsDiff = this.getTeamsDiff.bind(this);
    let allMemberCategories = _.flatMap(this.props.team.team_categories, (team_category) => {
      return team_category.member_categories;
    });
    this.state = {
      teams: this.checkStaticTeam(props.teams, props.team),
      allMemberCategories: allMemberCategories,
    };
  }

  componentWillReceiveProps(nextProps) {
    if(!_.isEqual(nextProps.teams, this.props.teams)) {
      this.setState({
        teams: this.checkStaticTeam(nextProps.teams, nextProps.team),
      });
    }
    if(!_.isEqual(nextProps.errors, this.props.errors)) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  checkStaticTeam(allTeams, team) {
    if (team.static_categories) {
      let missingTeams = _.map(team.team_categories, (category) => {
        if (!_.find(allTeams, {team_category: category.id})) {
          return {errors: [],
            team_type: team.id,
            _updated: true,
            members: [],
            member_estimates: [],
            position: category.position,
            estimated_members: null,
            _destroy: false,
            identifier: this.newID(),
            team_category: category.id};
          }
      });
      missingTeams = _.compact(missingTeams);
      allTeams = update(allTeams, {$push: missingTeams});
    }
    return allTeams;
  }

  updateTeam(details) {
    details = update(details, {_updated: {$set: true}});
    let index = _.findIndex(this.state.teams, {identifier: details.identifier});
    let teams = update(this.state.teams, {$splice: [[index, 1, details]]});
    this.props.updateTeamList(teams);
  }

  newID() {
    return '_' + Math.random().toString(36).substr(2, 20);
  }

  getTeamsDiff() {
    let deleted = [];
    let added = [];
    let changed = [];
    _(this.props.detailsDiff.teams).forEach((item, key) => {
      if (typeof item != 'string' && item[1] === 0 && item[2] === 0 && item[0].team_type == this.props.team.id) {
        deleted.push(item[0]);
      } else if(typeof item != 'string' &&
          item[1] === undefined &&
          item[2] === undefined &&
          item[0] !== undefined &&
          item[0].team_type == this.props.team.id) {
        added.push(item[0]);
      } else if(typeof item != 'string' && this.state.teams[key] &&
                this.state.teams[key].team_type == this.props.team.id) {
        let team = this.state.teams[key];
        let teamDiff = {
          isDifferent: true,
          id: team.id,
          team_type: team.team_type,
          ...item
        };
        changed.push(teamDiff);
      }
    });
    return {
      deleted,
      added,
      changed,
      allChanged: [...deleted, ...added, ...changed]
    };
  }

  render() {
    let diff = this.getTeamsDiff();
    let teams = _.filter(this.state.teams, {'team_type': this.props.team.id, '_destroy': false});
    if (this.props.team.static_categories) {
      teams = _.orderBy(teams, ['position']);
    } else {
      teams = _.orderBy(teams, ['created_at']);
    }
    let memberList  = this.props.regMemberList;
    // memberList = _.filter(memberList, (member) => {
    //   return !member.member_details.archived;
    // });
    let allMembers = _.flatMap(teams, 'members');
    let registeredMembers = _.filter(memberList, (regMember) => {
      return !_.find(allMembers, {member_reg: regMember.id, '_destroy': false});
    });
    if (this.props.team.unique_team_members) {
      memberList = registeredMembers;
    }
    if (this.props.show == false) {
      return null;
    }
    return (
      <div className="team-info-wrapper">
        <div className={'page-header'}>
          <h2>{this.props.team.name}</h2>
        </div>
        {this.props.team.description &&
          <div className="panel panel-default">
            <div className="panel-body">
              <RichDescription description={this.props.team.description} />
            </div>
          </div>
        }
        {!_.isEmpty(this.props.detailsDiff) && <div className="panel panel-warning">
          <div className="panel-heading">
            <FontAwesome name="warning" />
            &nbsp;
            Endringer som venter på godkjenning
          </div>
          <div className="panel-body">
            {this.props.team.name} lagt til: <strong>{_.size(diff.added)}</strong>
            <br/>
            {this.props.team.name} slettet: <strong>{_.size(diff.deleted)}</strong>
            <br/>
            {this.props.team.name} endret: <strong>{_.size(diff.changed)}</strong>
          </div>
        </div>}
        <div className="row mobile-switch-row">
          <div className="col-sm-6 mobile-switch">
            <RegMemberList list={memberList}
              registeredMembers={registeredMembers}
              uniqueTeamMembers={this.props.team.unique_team_members}
              />
          </div>
          <div className="col-sm-6 mobile-switch">
            <div className="panel panel-default">
              <ScrollZone
                className={'panel-body team-registration-list' + (
                  this.props.team.static_categories ? ' static' : ''
                )}>
                {teams.map((details) => {
                  let diffStatus = {};
                  let teamDiff = _.find(diff.allChanged, {id: details.id}) || {};
                  diffStatus['added'] = !_.isEmpty(_.filter(diff.added, {id: details.id}));
                  diffStatus['deleted'] = !_.isEmpty(_.filter(diff.deleted, {id: details.id}));
                  diffStatus['changed'] = !_.isEmpty(_.filter(diff.changed, {id: details.id}));
                  return (
                    <TeamForm key={details.identifier}
                      allMemberCategories={this.state.allMemberCategories}
                      removeTeam={this.props.removeTeam}
                      teamIndex={this.props.teamIndex}
                      teamDiff={teamDiff}
                      diffStatus={diffStatus}
                      updateTeam={this.updateTeam}
                      team={this.props.team}
                      details={details}
                      />
                  );
                })}
                {!_.isEmpty(diff.deleted) && <div className="page-header">
                  <h5 className="text-warning">
                    <FontAwesome name="warning" />
                    &emsp;
                    {'Slettede '}
                    {this.props.team.name.toLowerCase()}
                    {' (venter på endingsgodkjenning)'}
                  </h5>
                </div>}
                {diff.deleted.map((details) => {
                  let diffStatus = {};
                  let teamDiff = _.find(diff.deleted, {id: details.id}) || {};
                  diffStatus['deleted'] = !_.isEmpty(_.filter(diff.deleted, {id: details.id}));
                  return (
                    <TeamForm key={details.identifier}
                      allMemberCategories={this.state.allMemberCategories}
                      disabled={true}
                      removeTeam={this.props.removeTeam}
                      teamIndex={this.props.teamIndex}
                      teamDiff={teamDiff}
                      diffStatus={diffStatus}
                      updateTeam={this.updateTeam}
                      team={this.props.team}
                      details={details}
                      />
                  );
                })}
              </ScrollZone>
              {!this.props.team.static_categories && <div className="panel-footer">
                <button className={"btn btn-default"}
                  onClick={(e) => {
                    this.props.addTeam(this.props.team.id, this.props.team.team_categories[0].id, e);
                  }}
                  >
                  {"Legg til " + this.props.team.name.toLowerCase()}
                </button>
              </div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TeamInfo.propTypes = {
  actions: PropTypes.object.isRequired,
  addTeam: PropTypes.func.isRequired,
  removeTeam: PropTypes.func.isRequired,
  updateTeamList: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  teams: PropTypes.array.isRequired,
  regMemberList: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  route: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  clubDetails: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  eventId: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired,
  teamIndex: PropTypes.number.isRequired,
  detailsUpdated: PropTypes.number,
  errors: PropTypes.object,
  detailsDiff: PropTypes.object,
  loading: PropTypes.bool,
  show: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    loading: state.registration.loading,
    errors: state.registration.errors,
    eventDetails: state.events.eventDetails,
    clubDetails: state.clubs.clubDetails,
    eventId: ownProps.eventId,
    clubId: ownProps.clubId,
    detailsUpdated: state.registration.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamInfo));



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/TeamInfo.js
 **/